module.exports = __webpack_public_path__ + "static/media/play-button-icon.20059371.svg";